/**
 * LoginPage — Google OAuth sign-in screen
 *
 * Full-screen centered card with app branding and Google sign-in button.
 * Mobile-first: designed for phone screens first.
 */
import React from 'react';
import { useAuth } from '../contexts/AuthContext';

export default function LoginPage() {
  const { login } = useAuth();

  const handleLogin = async () => {
    try {
      await login();
    } catch (err) {
      console.error('Login failed:', err);
    }
  };

  return (
    <div className="login-screen">
      <div className="login-card">
        <span className="login-icon">💸</span>
        <h1>Spendable</h1>
        <p className="login-subtitle">How much can I safely spend right now?</p>
        <button className="google-btn" onClick={handleLogin}>
          <img
            src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
            alt="Google"
            width="20"
          />
          Sign in with Google
        </button>
      </div>
    </div>
  );
}
